import { Component, Input, ViewChild, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { BcConfigService } from '../../../common/config/provider';
import { BcAnalytics } from '../../../common/analytics/analytics.service';
import { FileSharingService } from '../../services/file-share/file-sharing.service';
import { WorkItemTypes } from '../../../common/workitems/constants/workitem-types';
import { EditorMessages } from '../editor-messages/editor-messages';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';

@Component({
  selector: 'app-file-upload-picker',
  templateUrl: './file-upload-picker.component.html',
  styleUrls: ['./file-upload-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileUploadPickerComponent implements OnInit, OnDestroy {
  @Input()
  public editorMessages: EditorMessages;
  @Input()
  public workItemId: string;
  @Input()
  public workItemType: WorkItemTypes;

  public selectedFile;
  public translateParams;
  private _fileSelectSubscription;

  @ViewChild('fileSelectButton', { static: true }) fileSelectButton;

  constructor(private _bcConfig: BcConfigService,
              private _bcAnalytics: BcAnalytics,
              public fileSharingService: FileSharingService,
              private _rxEmitter: RxEmitter) {
  }

  ngOnInit() {
    this._fileSelectSubscription = this._rxEmitter.subscribe(MessageBusEvents.OpenFileSelect, () => {
      this.fileSelectButton.nativeElement.click();
    });
  }

  ngOnDestroy() {
    if (this._fileSelectSubscription) {
      this._fileSelectSubscription.unsubscribe();
      this._fileSelectSubscription = null;
    }
  }

  dropFileHandler(event): any {
    const eventAttachment = event.attachment;
    const droppedFile = eventAttachment.file;

    // No attachment file
    if (typeof droppedFile === 'undefined' || droppedFile === null) {
      return false;
    }

    return this.uploadIfAllowed(droppedFile);
  }

  uploadIfAllowed(droppedFile) {
    this.editorMessages.removeEditorMessage('fileOverSizeLimit');

    const fileSize = parseInt((droppedFile.size / 1024).toString(), 10);
    const uploadSizeLimit = this.workItemType === WorkItemTypes.CHAT ? this._bcConfig.current.chatFileUploadSizeLimit : this._bcConfig.current.fileUploadSizeLimit;
    if (fileSize > uploadSizeLimit) {
      this.editorMessages.addEditorMessage(
        'fileOverSizeLimit',
        'bcChatBox.fileOverSizeLimit',
        { sizeLimit: uploadSizeLimit / 1024 });
    } else {
      this.fileSharingService.initiateUpload(droppedFile, this.workItemId, this.workItemType);
    }
  }

  uploadFile(file) {
    this.dropFileHandler({ attachment: { file } });
    this._bcAnalytics.eventTrack('FileShareInChat', { size: file && file.size });
  }
}
